module.exports = "/fonts/vendor/@fontsource/inter/files/inter-greek-ext-600-normal.woff2?b867239293019a5e0f46ce099b3586bf";